<template>
	<div class="producerListsModalBox">
		<el-dialog title="生产商列表" :visible="isShow" width="70%" @close="close" :center="true" top="1vh">
            <div class="producerListsModalContent">
                <hr>
                <ul>
                    <li  class="itemBox thead" >
                        <span class=" iconSpan" > 
                            <i class=""></i>
                        </span>
                        <span class=" nameSpan">公司姓名</span>
                        <span class=" idSpan">id</span>
                        <span class=" addressSpan">地址 </span>
                    </li>
                    <li v-for="(listProduce,index) in producerListsArr" class="itemBox" :class="{active:listProduce.isChosed==1}" @click="toggleList(listProduce)">
                        <span class=" iconSpan" > 
                            <i class="el-icon-success chosedIcon " v-if="listProduce.isChosed==1"></i>
                            <i class=""></i>
                        </span>
                        <span class=" nameSpan">{{listProduce.company_name}} </span>
                        <span class=" idSpan">{{listProduce.user_id}} </span>
                        <span class=" addressSpan"> {{listProduce.address}} </span>
                    </li>
                </ul>
            </div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close">取 消</el-button>
				<el-button type="primary" @click="submit" >确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		utils
	} from '@/common/common.js'
	import { ajaxPost } from '@/common/request.js'
     import {        ajaxApp,        api_app    } from '@/common/request_app.js'
	export default {
		name: 'authmodal',
		data() {
			return {
				producerListsArr:[]
			}
		},
		props:['isShow','hadChosedArr'],
		components: {},
		computed: {
		},
		methods: {
            getProducerLists() {
                let _this = this
                let arg={}
                console.log("开始获取生产商列表")
                ajaxApp('/yijiajiaUserAuth/producerList', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        let newArr=res.data.map((item,index)=>{
                            item.isChosed=false
                            return item
                        })
                        _this.producerListsArr=JSON.parse(JSON.stringify(res.data)) 
                    }
                }, function(res) {})
            },
            resetProducerLists(){
                let _this=this
                let newArr=_this.producerListsArr.map((item,index)=>{
                    let isChosedResult=false
                    _this.hadChosedArr.forEach(function(item2,index2){
                        if(item2.user_id==item.user_id){
                            isChosedResult=1
                        }
                    })
                    item.isChosed=isChosedResult
                    return item
                })
                _this.producerListsArr=newArr
            },
            toggleList(list){
                console.log(list)
                if(list.isChosed==1){
                    list.isChosed=false
                }else{
                    list.isChosed=1
                }
            },
			refresh(){
				this.$emit('submitSuccessFun',this.producerListsArr);
			},
			submit(){
				let _this=this
                _this.close()
                _this.refresh()
				
			},
			close(){
				console.log("emit close")
				this.$emit('close');
			}
		},
		mounted() {
            this.getProducerLists()
		}
	}
</script>

<style scoped lang="scss">
	.producerListsModalContent{
         height: 700px;
        overflow: auto;
        .itemSpan{display: inline-block;margin-right: 20px;}
        .itemBox:hover{background: #eee;cursor: pointer}
        .itemBox.active{background:skyblue;color:#fff;}
        .itemBox.thead{background: #ddd;color:#fff;}
        .itemBox{
            background: #eee;margin-bottom: 15px;
            padding:5px 20px;; font-size: 24px;
            .iconSpan{display: inline-block; width: 50px ;}
            .nameSpan{display: inline-block; width: 500px ;}  
            .idSpan{display: inline-block; width: 70px ;} 
            .addressSpan{display: inline-block; min-width: 270px ;}
        } 
    }
</style>



// WEBPACK FOOTER //
// src/components/producerListsModal.vue